import axios from 'axios';

import translateRules from 'actions/configuration/translateRules';

export default (async function(cdn, appId) {
  try {
    const response = await axios.get(`${cdn}/orgs/configs/chat/${appId}.json?q=${new Date().getTime()}`);
    response.data.rules = translateRules(response.data.rules); //until migration of old model happens

    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(`Failed to fetch configuration at: ${error.config.url}, response code: ${error.response.status}`);
    }
    if (error.request) {
      throw new Error(`Failed to fetch configuration at: ${error.config.url}, request timed out`);
    }

    throw new Error(`Failed to fetch configuration at: ${error.config.url}, ${error.message}`);
  }
});
